import _Object$fromEntries from "@babel/runtime-corejs3/core-js/object/from-entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import PropTypes from "prop-types";
export const plural = term => {
  if (typeof term === 'string') {
    return term;
  }
  const value = term.plural;
  if (!value) {
    throw new Error('Expected term to have a plural variation. Use a string or an object with a property named `plural`');
  }
  return value;
};
export const singular = term => {
  if (typeof term === 'string') {
    return term;
  }
  const value = term.singular;
  if (!value) {
    throw new Error('Expected term to have a singular variation. Use a string or an object with a property named `singular`');
  }
  return value;
};
export const humanTermType = keys => PropTypes.shape(_Object$fromEntries(_mapInstanceProperty(keys).call(keys, key => [key, PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  singular: PropTypes.string,
  plural: PropTypes.string
})])])));